import React from 'react'
import OnboardedLocations from '../components/OnboarderLocations'
import Header from '../components/Header'

function OnboardedPage() {
  return (
    <>
    <Header/>
    <OnboardedLocations/>
    </>
  )
}

export default OnboardedPage